import {CREATE_PARK_RATE,EDIT_PARK_RATE, PARKING_SPACE_NAME_ERROR,PARKING_SPACE_NAME_SUCCESS,SHOW_PARKING_SPACE_NAME } from './actionTypes';
import {getApi} from "../../services/httpService";

export const createParkRate = (parkRate) => {  
   
    return {
        type: CREATE_PARK_RATE,
        payload: { parkRate }
    }
}

export const showParkingSpaceName = (parkingSpaceName_id) => {
    return {
        type: SHOW_PARKING_SPACE_NAME,
        payload: { parkingSpaceName_id }
    }
}

export const editParkRate = (park_rate) => {
    return {
        type: EDIT_PARK_RATE,
        payload: { park_rate }
    }
}



export const parkingSpaceNameSuccess = (msg) => {
    return {
        type: PARKING_SPACE_NAME_SUCCESS,
        payload: msg
    }
}


export function parkingSpaceNameShow(parkingSpaceName_id){
    return getApi().get('parkingSpaceName/'+parkingSpaceName_id)
}


export function parkRateList(params){
    return getApi().get('ParkRate/list',{
        params: params
    })
}


export const parkingSpaceNameError = (error) => {
    return {
        type: PARKING_SPACE_NAME_ERROR,
        payload: error
    }
}
export function getParkInfoDropdown(params) {
    return getApi().get('ParkInfo/list',{
        params: params
    });
}
    
export function getDistrictDropdown(division_id,params) {
    return getApi().get('parkingSpaceName/district/'+division_id,{
        params: params
    });
  }

  export function getThanaDropdown(thana_id,params) {
    return getApi().get('parkingSpaceName/thana/'+thana_id,{
        params: params
    });
}
